import { Components, Theme } from "@mui/material/styles";

export const MuiTabs = () =>
  ({
    MuiTabs: {
      defaultProps: {
        textColor: "inherit",
        indicatorColor: "primary",
      },
    },
  }) satisfies Components<Theme>;
